import PouchLoadService from "external-services/pouch-load-service/index";

const NS = 'StructureService'; // jshint ignore:line

export default function StructureService(
  $q
) {
  "ngInject";

  var service = {
    get: get,
    save: save
  };

  return service;

  function get() {
    var deferred = $q.defer();
    PouchLoadService.getDbLocal().get('structure').then(function (data) {
      deferred.resolve(data);
    }).catch(function () {
      deferred.resolve({
        items: []
      });
    });
    return deferred.promise;
  }

  function save(structure) {
    structure.type = 'structure';
    structure._id = 'structure';

    return $q.when(PouchLoadService.getDbLocal().put(structure));
  }
}
